import script from "./Frenulotomija.vue?vue&type=script&setup=true&lang=ts"
export * from "./Frenulotomija.vue?vue&type=script&setup=true&lang=ts"

import "./Frenulotomija.vue?vue&type=style&index=0&id=41214b1b&lang=scss&scoped=true"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41214b1b"]])

export default __exports__